import '@hotmart/cosmos/dist/nav/nav.css'
import clsx from 'clsx'

import styles from './navPills.module.css'

import type { NavPillsProps, Evt, NavPillsItemProps } from './types'

const NavPills = ({ children }: NavPillsProps) => {
  return <hot-nav class='hot-nav--pills'>{children}</hot-nav>
}

const NavPillsItem = <T extends Evt>({
  children,
  onClick,
  isActive = false
}: NavPillsItemProps<T>) => {
  return (
    <hot-nav-item
      class={clsx('hot-nav__item', {
        [styles.active]: isActive
      })}
      onClick={onClick}>
      {children}
    </hot-nav-item>
  )
}

NavPills.Item = NavPillsItem

export default NavPills
